import React, { Component } from "react";
import { Form, Field } from "redux-form";

import userActivities from "../../constants/userActivities.js";

class SignupForm extends Component {
  render() {
    const { error, handleSubmit, handleCancel } = this.props;

    return (
      <Form onSubmit={handleSubmit} className="signup-form">
        {error && <div className="form__error">{error}</div>}

        {/* gender */}
        <div className="mb2">
          <span>{this.props.t("account:civilitySign")}</span>
          <div className="radio__field">
            <Field
              id="male"
              name="sex"
              component="input"
              type="radio"
              value="male"
              checked="checked"
            />
            <label htmlFor="male">{this.props.t("account:civilityMrSign")}</label>
          </div>
          <div className="radio__field">
            <Field
              id="female"
              className="form__field"
              name="sex"
              component="input"
              type="radio"
              value="female"
            />
            <label htmlFor="female">{this.props.t("account:civilityMrsSign")}</label>
          </div>
        </div>

        {/* lastname */}
        <Field
          className="form__field"
          name="lastname"
          component="input"
          type="text"
          placeholder={this.props.t("account:lastNameSign")}
        />

        {/* firstname */}
        <Field
          className="form__field"
          name="firstname"
          component="input"
          type="text"
          placeholder={this.props.t("account:firstNameSign")}
        />

        {/* company */}
        <Field
          className="form__field"
          name="company"
          component="input"
          type="text"
          placeholder={this.props.t("account:companyNameSign")}
        />

        {/* activity */}
        <Field
          className="form__field"
          name="activity"
          component="select"
          placeholder={this.props.t("userActivities:activity0title")}
          type="text"
        >
{
        /*
        account:{
          InscriptionPageTitle:"Register",
          civilitySign:"Gender*:",
          civilityMrSign:"Mr",
          civilityMrsSign:"Mrs",
          LastNameSign:"Last name*",
          firstNameSign:"First name*",
          companyNameSign:"Company*",
          addressSign:"Address*",
          citySign:"City*",
          postCodeSign:"Post Code*",
          CountrySign:"Country*",
          emailAddressSign:"your email*",
          emailAddressConfirmSign:"Confirm your email*",
          PasswordSign:"Your password*",
          PasswordConfirmSign:"Confirm your password*",
          RequiredSign:"* Required information"
        },
*/
}

          {userActivities.map((activity, id) => {
            return (
              <option key={id} value={activity.id}>
                {this.props.t("userActivities:activity" + activity.id + "title")}
              </option>
            );
          })}
        </Field>

        {/* address */}
        <Field
          className="form__field"
          name="address"
          component="textarea"
          placeholder={this.props.t("account:addressSign")}
          type="text"
        />

        {/* city / postal code */}
        <div className="contact__form-zip">
          <Field
            className="form__field"
            name="city"
            component="input"
            placeholder={this.props.t("account:citySign")}
            type="text"
          />
        </div>
        <div className="contact__form-city">
          <Field
            className="form__field"
            name="postalCode"
            component="input"
            placeholder={this.props.t("account:postCodeSign")}
            type="text"
          />
        </div>

        {/* country */}
        <Field
          className="form__field"
          name="country"
          component="input"
          placeholder={this.props.t("account:countrySign")}
          type="text"
        />

        {/* email */}
        <Field
          className="form__field"
          name="email"
          component="input"
          placeholder={this.props.t("account:emailAddressSign")}
          type="email"
        />

        {/* email confirmation */}
        <Field
          className="form__field"
          name="emailConfirmation"
          component="input"
          placeholder={this.props.t("account:emailAddressConfirmSign")}
          type="email"
        />

        {/* password */}
        <Field
          className="form__field"
          name="password"
          component="input"
          type="password"
          placeholder={this.props.t("account:passwordSign")}
        />

        {/* password confirmation */}
        <Field
          className="form__field"
          name="passwordConfirmation"
          component="input"
          type="password"
          placeholder={this.props.t("account:passwordConfirmSign")}
        />

        <div className="f7">
          {this.props.t("account:requiredSign")}
        </div>

        <div className="mt1 tc">
          {/* cancel */}
          <button type="button" className="button mr3" onClick={handleCancel}>
            {this.props.t("common:cancelButton")}
          </button>

          {/* submit */}
          <button className="button" type="submit">
            {this.props.t("common:submitButton")}&nbsp;<i className="i-arrow-right f7" />
          </button>
        </div>
      </Form>
    );
  }
}

export default SignupForm;



// WEBPACK FOOTER //
// ./src/components/forms/SignupForm.js